export const agencyTranslations = {
  HEB: {
    pageTitle: "ניהול סוכנות",
    activeAgents: "סוכנים פעילים",
    activeAgentsTooltip: "אלו הם סוכנים שיצרו משתמש במערכת ואישרו את ההזמנה לניהול חשבון הסוכן שלהם",
    licensesUsed: "רישיונות בשימוש",
    licensesUsedTooltip: "כל הזמנה לצירוף סוכן צורכת רישיון אחד.",
    totalLicenses: "סה\"כ רישיונות",
    availableLicenses: "רישיונות פנויים",
    totalAgents: "סה\"כ סוכנים",
    inviteNewAgents: "הזמן סוכנים חדשים לסוכנות שלך",
    agentCountIncrease: "מספר הסוכנים עלה ב-",
    lastMonth: "בחודש האחרון",
    totalManagedWorth: "שווי מנוהל כולל",
    totalManagedWorthTooltip: "סך השווי הנקי הכולל המנוהל על ידי כל הסוכנים בסוכנות",
    basedOnAgentData: "מבוסס על נתוני הסוכנים",
    noDataAvailable: "אין נתונים זמינים",
    agentGrowth: "גידול סוכנים",
    noAgentsYet: "אין סוכנים רשומים כרגע",
    noAgentsDescription: "הזמן סוכנים חדשים לסוכנות שלך כדי להתחיל לנהל את הרישיונות והלקוחות.",
    chartDate: "תאריך:",
    chartAgentCount: "כמות סוכנים:",
    agents: "סוכנים",
    searchPlaceholder: "חיפוש...",
    agent: "סוכן",
    agentCode: "קוד סוכן",
    creationDate: "תאריך יצירה",
    lastLogin: "התחברות אחרונה",
    clientCount: "מספר לקוחות",
    managedWorth: "שווי מנוהל",
    status: "סטטוס",
    noName: "אין שם",
    noEmail: "אין דוא\"ל",
    awaitingAssignment: "ממתין להקצאה",
    active: "פעיל",
    pending: "ממתין",
    neverLoggedIn: "לא התחבר עדיין",
    todayAt: "היום בשעה",
    yesterday: "אתמול",
    daysAgo: "ימים",
    daysAgoPrefix: "לפני",
    manageAgents: "ניהול סוכנים",
    manageAgentsDescription: "הזמן סוכנים חדשים לסוכנות שלך. ההזמנות יעבדו גם למשתמשים שעדיין לא רשומים במערכת.",
    inviteNewAgent: "הזמן סוכן חדש",
    noAvailableLicenses: "אין רישיונות פנויים",
    allLicensesUsed: "כל הרישיונות בשימוש. כל סוכן וכל הזמנה ממתינה צורכים רישיון אחד.",
    pendingInvites: "הזמנות ממתינות",
    noAvailableLicensesError: "אין רישיונות פנויים. כל סוכן וכל הזמנה ממתינה צורכים רישיון אחד.",

    // ── IncomingAgentInviteTable & AgentInviteList ─────────────
    inviteTable: {
      title: "הזמנות לסוכנות",
      showApproved: "הצג הזמנות מאושרות",
      statusHeader: "סטטוס",
      emailHeader: 'דוא"ל',
      agencyNameHeader: "שם הסוכנות",
      inviteDateHeader: "תאריך הזמנה",
      actionsHeader: "פעולות",
      statusPending: "ממתין",
      statusAccepted: "התקבל",
      statusRejected: "נדחה",
      approve: "אשר",
      reject: "דחה",
      noInvites: "אין הזמנות",
      noPendingInvites: "אין הזמנות ממתינות",
      invitesWillAppear: "ההזמנות יופיעו למשתמשים ברגע שהם יצטרפו למערכת",
      agencyFallback: "סוכנות",
    },

    // ── IncomingAgentInviteSnackbar ────────────────────────────
    inviteSnackbar: {
      reject: "דחה",
      accept: "קבל",
      inviteMessage: "הזמנה לניהול סוכן בסוכנות",
      rejectedInvite: "דחית את ההזמנה לסוכנות",
      rejectedInviteError: "שגיאה בדחיית ההזמנה לסוכנות",
      acceptedInvite: "קיבלת את ההזמנה לסוכנות",
      acceptedInviteError: "שגיאה בקבלת ההזמנה לסוכנות",
    },
  },
  ENG: {
    pageTitle: "Agency Management",
    activeAgents: "Active Agents",
    activeAgentsTooltip: "These are agents who created an account in the system and accepted the invitation to manage their agent account",
    licensesUsed: "Licenses Used",
    licensesUsedTooltip: "Each invitation to add an agent uses one license.",
    totalLicenses: "Total Licenses",
    availableLicenses: "Available Licenses",
    totalAgents: "Total Agents",
    inviteNewAgents: "Invite new agents to your agency",
    agentCountIncrease: "Agent count increased by ",
    lastMonth: " last month",
    totalManagedWorth: "Total Managed Worth",
    totalManagedWorthTooltip: "Total net worth managed by all agents in the agency",
    basedOnAgentData: "Based on agent data",
    noDataAvailable: "No data available",
    agentGrowth: "Agent Growth",
    noAgentsYet: "No registered agents yet",
    noAgentsDescription: "Invite new agents to your agency to start managing licenses and clients.",
    chartDate: "Date:",
    chartAgentCount: "Agent count:",
    agents: "Agents",
    searchPlaceholder: "Search...",
    agent: "Agent",
    agentCode: "Agent Code",
    creationDate: "Creation Date",
    lastLogin: "Last Login",
    clientCount: "Client Count",
    managedWorth: "Managed Worth",
    status: "Status",
    noName: "No name",
    noEmail: "No email",
    awaitingAssignment: "Awaiting assignment",
    active: "Active",
    pending: "Pending",
    neverLoggedIn: "Never logged in",
    todayAt: "Today at",
    yesterday: "Yesterday",
    daysAgo: "days ago",
    daysAgoPrefix: "",
    manageAgents: "Manage Agents",
    manageAgentsDescription: "Invite new agents to your agency. Invitations also work for users not yet registered in the system.",
    inviteNewAgent: "Invite New Agent",
    noAvailableLicenses: "No available licenses",
    allLicensesUsed: "All licenses are in use. Each agent and pending invitation uses one license.",
    pendingInvites: "Pending Invites",
    noAvailableLicensesError: "No available licenses. Each agent and pending invitation uses one license.",

    // ── IncomingAgentInviteTable & AgentInviteList ─────────────
    inviteTable: {
      title: "Agency Invitations",
      showApproved: "Show approved invitations",
      statusHeader: "Status",
      emailHeader: "Email",
      agencyNameHeader: "Agency Name",
      inviteDateHeader: "Invitation Date",
      actionsHeader: "Actions",
      statusPending: "Pending",
      statusAccepted: "Accepted",
      statusRejected: "Rejected",
      approve: "Approve",
      reject: "Reject",
      noInvites: "No invitations",
      noPendingInvites: "No pending invitations",
      invitesWillAppear: "Invitations will appear to users once they join the system",
      agencyFallback: "Agency",
    },

    // ── IncomingAgentInviteSnackbar ────────────────────────────
    inviteSnackbar: {
      reject: "Reject",
      accept: "Accept",
      inviteMessage: "Invitation to manage an agent in agency",
      rejectedInvite: "You rejected the invitation to agency",
      rejectedInviteError: "Error rejecting the invitation to agency",
      acceptedInvite: "You accepted the invitation to agency",
      acceptedInviteError: "Error accepting the invitation to agency",
    },
  },
  RUS: {
    pageTitle: "Управление агентством",
    activeAgents: "Активные агенты",
    activeAgentsTooltip: "Это агенты, которые создали аккаунт в системе и приняли приглашение на управление своим агентским аккаунтом",
    licensesUsed: "Использовано лицензий",
    licensesUsedTooltip: "Каждое приглашение агента использует одну лицензию.",
    totalLicenses: "Всего лицензий",
    availableLicenses: "Доступные лицензии",
    totalAgents: "Всего агентов",
    inviteNewAgents: "Пригласить новых агентов в ваше агентство",
    agentCountIncrease: "Количество агентов увеличилось на ",
    lastMonth: " за последний месяц",
    totalManagedWorth: "Общая управляемая стоимость",
    totalManagedWorthTooltip: "Общая чистая стоимость, управляемая всеми агентами в агентстве",
    basedOnAgentData: "На основе данных агентов",
    noDataAvailable: "Нет доступных данных",
    agentGrowth: "Рост агентов",
    noAgentsYet: "Зарегистрированных агентов пока нет",
    noAgentsDescription: "Пригласите новых агентов в ваше агентство, чтобы начать управлять лицензиями и клиентами.",
    chartDate: "Дата:",
    chartAgentCount: "Количество агентов:",
    agents: "Агенты",
    searchPlaceholder: "Поиск...",
    agent: "Агент",
    agentCode: "Код агента",
    creationDate: "Дата создания",
    lastLogin: "Последний вход",
    clientCount: "Количество клиентов",
    managedWorth: "Управляемая стоимость",
    status: "Статус",
    noName: "Нет имени",
    noEmail: "Нет email",
    awaitingAssignment: "Ожидает назначения",
    active: "Активен",
    pending: "Ожидает",
    neverLoggedIn: "Ещё не входил",
    todayAt: "Сегодня в",
    yesterday: "Вчера",
    daysAgo: "дней назад",
    daysAgoPrefix: "",
    manageAgents: "Управление агентами",
    manageAgentsDescription: "Пригласите новых агентов в ваше агентство. Приглашения также работают для пользователей, ещё не зарегистрированных в системе.",
    inviteNewAgent: "Пригласить нового агента",
    noAvailableLicenses: "Нет доступных лицензий",
    allLicensesUsed: "Все лицензии используются. Каждый агент и ожидающее приглашение занимает одну лицензию.",
    pendingInvites: "Ожидающие приглашения",
    noAvailableLicensesError: "Нет доступных лицензий. Каждый агент и ожидающее приглашение занимает одну лицензию.",

    // ── IncomingAgentInviteTable & AgentInviteList ─────────────
    inviteTable: {
      title: "Приглашения в агентство",
      showApproved: "Показать одобренные приглашения",
      statusHeader: "Статус",
      emailHeader: "Email",
      agencyNameHeader: "Название агентства",
      inviteDateHeader: "Дата приглашения",
      actionsHeader: "Действия",
      statusPending: "Ожидает",
      statusAccepted: "Принято",
      statusRejected: "Отклонено",
      approve: "Одобрить",
      reject: "Отклонить",
      noInvites: "Нет приглашений",
      noPendingInvites: "Нет ожидающих приглашений",
      invitesWillAppear: "Приглашения появятся у пользователей после присоединения к системе",
      agencyFallback: "Агентство",
    },

    // ── IncomingAgentInviteSnackbar ────────────────────────────
    inviteSnackbar: {
      reject: "Отклонить",
      accept: "Принять",
      inviteMessage: "Приглашение на управление агентом в агентстве",
      rejectedInvite: "Вы отклонили приглашение в агентство",
      rejectedInviteError: "Ошибка при отклонении приглашения в агентство",
      acceptedInvite: "Вы приняли приглашение в агентство",
      acceptedInviteError: "Ошибка при принятии приглашения в агентство",
    },
  },
};
